module.exports = __webpack_public_path__ + "img/default_bg.2601ed0.png";